import { useQuery } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';
import {
  EarningsInsightFilterResponse,
  earningsInsights,
  EarningsInsightsFilterRequest,
  EarningsInsightType,
} from '@toggle/toggle';
import { useMemo } from 'react';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

const QUERY_KEY_EARNINGS_INSIGHTS_FILTER = 'QUERY_KEY_EARNINGS_INSIGHTS_FILTER';

export const useEarningsInsightsFilter = ({
  body = {},
  isEnabled = true,
  earningsTypes,
}: {
  body?: EarningsInsightsFilterRequest;
  isEnabled?: boolean;
  earningsTypes?: EarningsInsightType[];
}) => {
  const { data, isFetching, isError, error } = useQuery({
    queryKey: [QUERY_KEY_EARNINGS_INSIGHTS_FILTER, body],
    queryFn: ({ signal }) => {
      const { path, schema } = earningsInsights.postEarningsInsightFilter;
      return wretchRequest<EarningsInsightFilterResponse>(path, {
        method: 'post',
        body,
        schema,
        signal,
      });
    },
    staleTime: getTimeTillEndOfDayMs(),
    enabled: isEnabled,
  });

  const earningsInights = useMemo(() => {
    return (data ?? [])
      .filter(i => !earningsTypes || earningsTypes.includes(i.type))
      .map(insight => {
        return {
          ...insight,
          date: insight.created_at,
        };
      });
  }, [data, earningsTypes]);

  return {
    data: earningsInights,
    isFetching,
    isError,
    error,
  };
};
